import CosmoDbContext from './CosmoDbContext';

const contexts = new Map<string, CosmoDbContext>();

const getContext = (dirname: string): CosmoDbContext => {
    let context = contexts.get(dirname);
    if (typeof context === 'undefined') {
        context = new CosmoDbContext(`/modules/${dirname}`);
        contexts.set(dirname, context);
    }
    return context;
};

const getThumbnailSize = (paramSize: string | null, thumbSize: string) => {
    const options = thumbSize.split(';').map((value) => value.split(','));
    if (options.length === 0 || options.filter((value) => value.length !== 4).length !== 0) {
        return null;
    }
    const size = paramSize === null ? options[0][0] : paramSize;
    const option = options.find((value) => value[0] === size);
    if (typeof option === 'undefined') {
        return null;
    }
    const imgWidth = /^\d+$/.test(option[1]) ? parseInt(option[1], 10) : 0;
    const imgHeight = /^\d+$/.test(option[2]) ? parseInt(option[2], 10) : 0;
    const maxCol = /^\d+$/.test(option[3]) ? parseInt(option[3], 10) : 0;
    if (imgHeight < 0 || imgWidth < 0 || maxCol <= 0) {
        return null;
    }
    return {
        name: option[0],
        height: imgHeight,
        width: imgWidth,
        maxCol: maxCol,
    };
};

const CosmoDbUtils = {
    getContext,
    getThumbnailSize,
};

export default CosmoDbUtils;
